<template>
        <div id="contenedor-pasoUno" class="padding-div-low" >
            
            <div class="area">
                <div id="subidordearchivos_div text-left">
                    <h5>Paso 1: Seleccione micrositio,página y sección</h5>
                    <hr />
                
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <h6 style="padding: 5px">Micrositio</h6>
                        <C001PaginaInicio   v-on:valorParaElPadre="cambioMicrositio" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoPaginaPasoUno'" :parametros="{PaginaDeInicioId: null,MenuId: null,SubmenuId: null,TipoContenedorId: null,ConPaginaDeInicio: false,ConMenu: false,ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true}" :valorDefinido="tipoDePaginaWebId"></C001PaginaInicio>
                       </div>
                       <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <h6  style="padding: 5px">Página&nbsp;</h6>
                        <C013PaginasMicrositio  v-on:valorParaElPadre="cambioIdPaginaMic" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoPaginaMicrositioPasoUno'" :parametros="{PaginaMicrositioId:null,PaginaDeInicioId: idMicrositio,MenuId: null,SubmenuId: null,SeccionDeMicrositioId: null,ConSecciones:false,ConPaginaDeInicio: false,ConTipoContenedor: false,ConInactivas:false,FiltrarPorUsuario:true}" :valorDefinido="-1" :key="idMicrositio+'|M'"></C013PaginasMicrositio>
                        </div>
                        <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <h6   style="padding: 5px;">Sección</h6>
                        <C014SeccionesDelMicrositio  style="padding:0; margin:0;" v-on:valorParaElPadre="cambioIdSeccion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoSeccionPasoUno'" :parametros="{PaginaMicrositioId: idPaginaMicrositio,SeccionMicrositioId:null, TipoFormatoId: null, ConActivo: true, ConContenido:false,ConTipoFormato:true}" :valorDefinido="-1" :key="idPaginaMicrositio"></C014SeccionesDelMicrositio>
                        <CSelectGenerico v-for="subseccion in subseccionesDePagianWeb" class="subscciones" v-on:valorParaElPadre="cambioTipoSubseccion" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="subseccion.idDelInput" :valorDefinido="-1" :key="subseccion.key" :elementos="subseccion.subsecciones" :mansajeValorDefinidoPlural="'las secciónes'" :mansajeValorDefinidoSingular="'un tipo de sección'"></CSelectGenerico>
                   </div>
                   <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <h6  style="padding: 5px">Que contenga el texto&nbsp;</h6>
                          <input v-model="textoDeBusqueda" type="text" id="texto-busqueda" :class="'form-control'" placeholder="Texto para buscar" />
                        </div>
                        
                         <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                        <h6  style="padding: 5px">Nombre del Archivo&nbsp;</h6>
                          <input v-model="textoVinculo" type="text" id="texto_vinculo_contenido" :class="'form-control'" placeholder="Ingrese titulo del Menu" />
                        </div>

                          <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3" style="top:4vh">
                           <select v-model="seleccionDeFecha" class="form-control" @change="entreFechas=seleccionDeFecha">
                               <option :value="false">Buscar registros en la fecha</option>
                               <option :value="true">Buscar registros entre fechas</option>
                           </select>     
                        </div>

                        <div class="col-12 col-sm-12 col-md-3col-lg-3 col-xl-3">
                          <h6  style="padding: 5px">Fecha&nbsp;<font v-if="entreFechas">Inicial</font></h6>
                          <Datepicker :bootstrap-styling="true" v-model="fechaInicial" :language="lenguaje" :format="lenguaje.ymd"  class="form-control"></Datepicker>
                         <h6 v-if="entreFechas"  style="padding: 5px">Fecha Final&nbsp;</h6>
                         <Datepicker v-if="entreFechas" :bootstrap-styling="true" v-model="fechaFinal" :language="lenguaje" :format="lenguaje.ymd" class="form-control"></Datepicker>
                       </div>
                    
                    </div>
                    <div >

                        <div class="text-right" style="margin-top: 20px;">                         
                             <div class="d-flex justify-content-end mt-4">
                <button @click="limpiarFiltro" type="button" class="btn btn-primary ml-2"><i class="fas fa-broom"></i>&nbsp;&nbsp;Limpiar Filtro</button>
                <button @click="evtBusquedaContenidos" type="button" class="btn btn-primary ml-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
            </div> 
                        </div> 
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  import catalogos from '@/../static/js/catalogos'
  import enumeraciones from '@/../static/js/enumeraciones'
  import formatos from '@/../static/js/enumeraciones/sicpo.js'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
  import C001PaginaInicio from '@/components/SICPO/Catalogos/C001PaginaInicio.vue'
  import C013PaginasMicrositio from '@/components/SICPO/Catalogos/C013PaginasMicrositio.vue'
  import C014SeccionesDelMicrositio from '@/components/SICPO/Catalogos/C014SeccionesDeMicrositio.vue'
  import C015SelectDelContenido from '@/components/SICPO/Catalogos/C015SelectContenidoMicrositio.vue'
  import Datepicker from 'vuejs-datepicker';
   


  export default {
      data() {
          return {
                lenguaje:{
                language: 'es',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                rtl: false,
                ymd: 'yyyy-MM-dd',
                yearSuffix: ''
            },
              seleccionDeFecha:false,
              textoDeBusqueda:null,
              textoVinculo:null,
              entreFechas:false,
              enumeraciones,
             fechaInicial:null,
             fechaFinal:null,
            idPaginaMicrositio:0,
            idMicrositio:0,
            seccionId:0,
            tipoDePaginaWebId: -1,
            subseccionesDePagianWeb: []
          }
      },
      components: {
         C013PaginasMicrositio,
         C014SeccionesDelMicrositio,
         C015SelectDelContenido,
         CSelectGenerico,
         C001PaginaInicio,
         Datepicker   
      },
      methods: {
             obtenerFecha: function(fecha) {
            let fechaActual = fecha;
            let mes = '' + (fechaActual.getMonth() + 1);
            let dia = '' + fechaActual.getDate();
            let year = fechaActual.getFullYear();

            if (mes.length < 2) 
                mes = '0' + mes;
            if (dia.length < 2) 
                dia = '0' + dia;
            return [year, mes, dia].join('-');
        },
        limpiarFiltro:function(){
            this.seccionId=-1;
            this.textoDeBusqueda=null;
            this.textoVinculo=null;
            this.fechaInicial=null;
            this.fechaFinal=null;
        },

          evtBusquedaContenidos: function() {
            const FILTROS_BUSQUEDA = {
               MicrositioId:this.idMicrositio,
                PaginaId: this.idPaginaMicrositio,
                SeccionId:this.seccionId,
                TipoEstatus:2,
                TextoDeBusqueda:this.textoDeBusqueda,
                NombreDeRecurso:this.textoVinculo,
                FechaInicial:  (this.fechaInicial!=null)?this.obtenerFecha(this.fechaInicial):null,
                FechaFinal: (this.fechaFinal!=null)?this.obtenerFecha(this.fechaFinal):null              
            }
            this.$emit('buscaFiltros', FILTROS_BUSQUEDA);
        },
         cambioMicrositio:function(evento){
              this.idMicrositio = evento.target.value;
              this.idPaginaMicrositio=0;
          },
        cambioIdPaginaMic: function (evento) {
             this.idPaginaMicrositio = evento.target.value;
              this.seccionId = 0;         
        },
        cambioIdSeccion: function (evento) {
            this.seccionId = evento.target.value;           
        },
        
      },

    
  }
</script>
<style scoped>


.tipoDePagina_DIV {
    display: flex;
    
}
#subidordearchivos_div {
    text-align: center
}
.vr {
    width:1px;
    background-color: white;
    margin-left: 15px;
}

.secciones {
    margin-top: 20px;
}

.subscciones {
    padding:0; 
    margin: 0;
    margin-top: 6px;
}
h5, h6{
        user-select: none;
}

.desabilitar-div-pasoUno {
    pointer-events: none;
    opacity: 0.4;
}

#pasoUno-aviso-secciones {
     padding: 1em;
     background-color: #26272b;
     border: 1px solid #5c5959;
     border-radius: 8px;
     margin-bottom: 1em;;
 }

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/BusquedaDeDocumentosMicrositios/CFiltrosDocumentosMicrositios.vue